import React, { useState } from "react"
import { v4 as uuidv4 } from "uuid"
import { FilterBox, Wrapper, Select, ResetButton, Item, Title, WrapperActiveFilter } from "./Filters.style"
import { useDetectDevice } from "../../../lib/useDetectDevice"
import { gtagger } from "../../../helper/gtag"
import { useDispatch } from "react-redux"
import { clearAnchorAll } from "../../../entities/anchorListitem/anchorListItem.actions"
import { PropsFilter } from "./Filters.container"
import { Icon } from "../Icon"
import { navigate } from "gatsby"

export interface Props extends PropsFilter {
  Shrunked: boolean
}

const getFiltersFromUrl = () => {
  var params = window.location.search.slice(1).split("&").filter(item => item != "")

  if (params.lenght <= 0) return

  var res = {}
  params.forEach(param => {
    const item = param.split("=")
    const key = item[0]
    //%3B equivalent a ;
    const values = item[1]?.split("%3B") || []
    const uniqueValues = [...new Set(values)];
    if (key != "r") {
      res[key] ? res[key].push(values) : res[key] = uniqueValues
    }
  })
  return res
}

const setUrlFromFilters = filters => {
  const url = new URL(window.location)
  url.search = ""
  Object.keys(filters).map(key => {
    const items = [...new Set(filters[key])];
    if (filters[key]) url.searchParams.set(key, items.join(';'))
  })
  window.history.pushState({}, "", url)
}

export function FiltersView({
  Shrunked,
  className,
  filters = [],
  onFiltersChange,
  onClearFilter,
}: Props) {
  const [activeFilters, setActiveFilters] = useState(getFiltersFromUrl())
  const isMobile = useDetectDevice()
  const classNames = (className && className) + " " + (isMobile && "mobile")
  const dispatch = useDispatch()
  const handleChange = e => {

    var filterSlug: string = e.target.dataset.filterslug
    var value = e.target.value as string
    var res = { ...activeFilters }
    res[filterSlug] ? res[filterSlug].push(value) : res[filterSlug] = [value]
    setActiveFilters(res)
    setUrlFromFilters(res)
    onFiltersChange(res)
    dispatch(clearAnchorAll())
    gtagger("filter change", { "value": res })
  }

  const handleRemoveItem = (res) => {

    if (!Object.keys(res).length) {
      return navigatePaginatePage()
    }

    setActiveFilters(res)
    setUrlFromFilters(res)
    onFiltersChange(res)
    dispatch(clearAnchorAll())
    gtagger("filter change", { "value": res })
  }

  const hasActiveFilter = Object.keys(activeFilters).length !== 0
  return (
    <FilterBox className={classNames} Shrunked={!isMobile && Shrunked} hasActiveFilter={hasActiveFilter}>
      <FilterSelectedItem filters={activeFilters} onChange={handleRemoveItem} shrunked={Shrunked} >
        {/* <ResetButton className={isMobile && "mobile"} onClick={onClearFilter}>
          Effacer les filtres
        </ResetButton> */}
      </FilterSelectedItem>
      <Wrapper>
        {
          Object.keys(filters).map(key => {

            if (filters[key].length <= 0) return <></>

            //trouver le filterSlug (le meme pour tous les enfants )
            let filterSlug = ""
            filterSlug = filters[key]?.find(item => item.filterSlug != null)?.filterSlug

            return (
              <Select
                className={classNames}
                name={filterSlug}
                data-filterslug={filterSlug}
                onChange={handleChange}
                key={uuidv4()}
              // defaultValue={getValue(filterSlug)}
              >
                <option value={""}>{key}</option>
                {filters[key].map(value => {
                  return (
                    <option key={uuidv4()} value={value.slug} >
                      {value.name}
                    </option>
                  )
                })}
              </Select>
            )
          })}

      </Wrapper>

    </FilterBox>)
}

const FilterSelectedItem = ({ filters, shrunked, className, onChange, children }) => {
  const buildFIlterItem = (filter, index) => {
    const [typeFilter, values] = filter
    if (typeFilter) {
      return (
        <Items className={className} values={values} typeFilter={typeFilter} key={uuidv4()}
          onRemove={
            (slugToRemove: number) => {

              let filterTemp = { ...filters }

              filterTemp[typeFilter] = filterTemp[typeFilter].filter(i => i != slugToRemove)

              if (filterTemp[typeFilter].some(x => !x) || !filterTemp[typeFilter]?.length) {

                delete filterTemp[typeFilter]
              }

              return onChange({ ...filterTemp })
            }
          } />
      )
    }

  }

  return (
    <WrapperActiveFilter >
      {(!shrunked && Object.entries(filters).length) ? (<Title>Vous avez sélectionné</Title>) : <></>}
      <Wrapper>
        {Object.entries(filters).map((filter, index) => buildFIlterItem(filter, index))}
      </Wrapper>
    </WrapperActiveFilter>
  )
}

const Items = ({ typeFilter, values, onRemove }) => {
  return (<>
    {values.map((item, index) => {
      if (item) {
        return (
          <Item key={uuidv4()} onClick={() => onRemove(item)}>
            <Icon icon="cross" /> {item}
          </Item>
        )
      }
    })}
  </>)
}

const navigatePaginatePage = () => {

  let url = new URL(window.location.href)
  const regex = /\/voir-tout\/?/s;

  let urlFinal = new URL(url.pathname.replace(regex, ""), url)
  const slug = urlFinal.pathname
  return url && navigate(slug)
}